export function TestSkeletonCard() {
  return (
    <div className="flex animate-pulse items-center gap-5 rounded-xl border border-border/70 bg-card p-5">
      <div className="flex w-14 shrink-0 flex-col items-center gap-2">
        <div className="h-8 w-10 rounded bg-muted" />
        <div className="h-2 w-12 rounded bg-muted/60" />
      </div>
      <div className="hidden h-12 w-px bg-border/70 sm:block" />
      <div className="flex-1 space-y-2">
        <div className="h-5 w-1/2 rounded bg-muted" />
        <div className="h-3 w-1/3 rounded bg-muted/60" />
      </div>
    </div>
  );
}
